import { blue } from "./PDFColors";
import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  topNavigation: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "5px",
    marginTop: "5px",
  },
  center: {
    justifyContent: "center",
    alignItems: "center",
  },

  navigationBox: {
    width: "110pt",
    height: "5pt",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    marginHorizontal: "14px",
  },
  navigationBoxSelected: {
    width: "110pt",
    height: "5pt",
    borderStyle: "solid",
    borderColor: blue,
    backgroundColor: blue,
    borderWidth: "1pt",
    marginHorizontal: "14px",
  },

  text: { textAlign: "left", fontSize: "11px", marginTop: "2px" },
});
